import { useMemo } from 'react';

import type { Logger } from '../../lib/logger.config';

import { LoggerContext } from '../../hooks/use-logger';

export type LoggerProviderProps = {
    children: React.ReactNode;
    logger: Logger;
};

export function LoggerProvider({ children, logger }: LoggerProviderProps) {
    const contextValue = useMemo(() => ({ logger }), [logger]);

    return <LoggerContext value={contextValue}>{children}</LoggerContext>;
}
